module.exports = __webpack_public_path__ + "static/media/font_medium.1c40042c.woff";